var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footbtn"},[_c('div',{staticClass:"btn-box"},[_c('van-button',{staticClass:"primary",attrs:{"disabled":_vm.disabled},on:{"click":_vm.click_btn}},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"box-shaow"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }